import { PropsWithChildren, ReactNode } from 'react'

interface GuardProps extends PropsWithChildren<{}> {
  condition?: boolean | boolean[]
  some?: boolean | boolean[]
  fallback?: ReactNode
}

export const Guard = ({
  children,
  condition = true,
  fallback = null,
  some,
}: GuardProps): JSX.Element => {
  const isAllowed = Array.isArray(condition) ? condition.every(Boolean) : condition

  const someAllowed =
    typeof some === 'undefined' ? true : Array.isArray(some) ? some.some(Boolean) : some

  if (!isAllowed || !someAllowed) {
    return <>{fallback}</>
  }

  return <>{children}</>
}
